<template>
  <div class="material-edit">
    <el-card>
      <div slot="header" class="card-header">
        <span>{{ isEdit ? $t('materials.dialogEditTitle') : $t('materials.dialogTitle') }}</span>
      </div>
      <el-form :model="form" label-width="100px">
        <el-form-item :label="$t('materials.labelName')">
          <el-input v-model="form.name" :placeholder="$t('materials.phName')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('materials.labelType')">
          <el-select v-model="form.type" :placeholder="$t('materials.typePlaceholder')" style="width: 100%;">
            <el-option :label="$t('materials.matVideo')" value="video"></el-option>
            <el-option :label="$t('materials.matImage')" value="image"></el-option>
            <el-option :label="$t('materials.matAudio')" value="audio"></el-option>
            <el-option :label="$t('materials.matFile')" value="file"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('materials.uploadFile')">
          <el-upload
            action=""
            :http-request="handleUpload"
            :show-file-list="false"
            accept="video/*,image/*,audio/*,.pdf,.doc,.docx,.xls,.xlsx"
          >
            <el-button size="small" type="primary">{{ $t('materials.selectFile') }}</el-button>
            <span v-if="form.url" class="upload-tip">{{ $t('materials.uploadedTip') }}{{ form.url }}</span>
          </el-upload>
        </el-form-item>
        <el-form-item :label="$t('materials.labelUrl')">
          <el-input v-model="form.url" :placeholder="$t('materials.phUrl')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('materials.labelDuration')" v-if="form.type === 'video' || form.type === 'audio'">
          <el-input-number v-model="form.duration" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('materials.labelSize')">
          <el-input-number v-model="form.size" :min="0"></el-input-number>
          <span class="unit-tip">{{ $t('materials.bytes') }}</span>
        </el-form-item>
        <el-form-item :label="$t('materials.status')">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">{{ $t('materials.statusActive') }}</el-radio>
            <el-radio :label="0">{{ $t('materials.statusInactive') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="submitLoading" @click="handleSubmit">{{ $t('materials.save') }}</el-button>
          <el-button @click="$router.back()">{{ $t('materials.cancel') }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getDetail, save, update, upload } from '@/api/materials'

export default {
  name: 'MaterialsEdit',
  data() {
    return {
      isEdit: false,
      submitLoading: false,
      form: {
        id: null,
        name: '',
        type: 'image',
        url: '',
        duration: 0,
        size: 0,
        status: 1
      }
    }
  },
  created() {
    const id = this.$route.params.id
    if (id) {
      this.isEdit = true
      this.loadDetail(id)
    }
  },
  methods: {
    loadDetail(id) {
      getDetail(id).then(res => {
        const data = res.data || {}
        this.form = {
          id: data.id,
          name: data.name,
          type: data.type,
          url: data.url,
          duration: data.duration || 0,
          size: data.size || 0,
          status: data.status
        }
      }).catch(() => {
        this.$message.error(this.$t('materials.loadDetailFail'))
      })
    },
    handleUpload(options) {
      const formData = new FormData()
      formData.append('file', options.file)
      upload(formData).then(res => {
        const data = res.data
        this.form.url = data.url
        this.form.type = data.type
        this.form.size = data.size
        if (data.duration) {
          this.form.duration = data.duration
        }
        if (!this.form.name) {
          this.form.name = options.file.name
        }
        this.$message.success(this.$t('materials.uploadSuccess'))
      }).catch(() => {
        this.$message.error(this.$t('materials.uploadFail'))
      })
    },
    handleSubmit() {
      if (!this.form.name) {
        this.$message.warning(this.$t('materials.nameRequired'))
        return
      }
      if (!this.form.url) {
        this.$message.warning(this.$t('materials.urlRequired'))
        return
      }
      this.submitLoading = true
      const api = this.isEdit ? update(this.form.id, this.form) : save(this.form)
      api.then(() => {
        this.$message.success(this.isEdit ? this.$t('materials.updateSuccess') : this.$t('materials.createSuccess'))
        this.$router.push('/materials')
      }).catch(() => {
        this.$message.error(this.$t('materials.saveFail'))
      }).finally(() => {
        this.submitLoading = false
      })
    }
  }
}
</script>

<style scoped>
.card-header {
  font-weight: bold;
  font-size: 16px;
}
.upload-tip {
  margin-left: 10px;
  color: #67c23a;
  font-size: 12px;
}
.unit-tip {
  margin-left: 10px;
  color: #909399;
  font-size: 12px;
}
</style>
